import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  switchMap,
  takeUntil,
} from 'rxjs/operators';

export interface Error {
  name: string;
  messageI18n: string;
}

@Component({
  selector: 'orderform-input-errors',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss'],
  // needed to pass formgroup validation throw components
  changeDetection: ChangeDetectionStrategy.Default,
})
export class InputErrorsComponent implements OnDestroy {
  // For single error message
  @Input() error? = '';
  @Input() fieldName?: string;
  @Input() errors?: ValidationErrors;

  private _control$ = new BehaviorSubject<AbstractControl>(null);
  @Input() set control(c: AbstractControl) {
    this._control$.next(c);
  }
  get control(): AbstractControl {
    return this._control$.value;
  }
  @Input() formErrors: Error[];
  @Input() regexMessage?: string;

  private _destroy$ = new Subject<void>();

  constructor(private _cd: ChangeDetectorRef) {
    this._control$
      .pipe(
        takeUntil(this._destroy$),
        filter((c) => !!c),
        switchMap((c) => c.statusChanges)
      )
      .subscribe(() => this._cd.detectChanges());
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
